
import OverlayPanel from "primevue/overlaypanel";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  key = prop<string>({ required: true });
  list = prop<string[]>({ required: true });
  limitRender = prop<number>({ default: 6 });
  title = prop<string>({ required: true });
  pillTitle = prop<boolean>({ default: false });
}

@Options({
  name: "CardPopupOtherTag",
  components: { OverlayPanel }
})
export default class CardPopupOtherTag extends Vue.with(Props) {
  page = 1;
  get renderList() {
    return [...this.list].splice(
      (this.page - 1) * this.limitRender,
      this.limitRender
    );
  }
  get totalPage() {
    return Math.ceil(this.list.length / this.limitRender);
  }
  onPrev() {
    if (this.page > 1) {
      this.page -= 1;
    }
  }
  onNext() {
    if (this.list.length > this.page * this.limitRender) {
      this.page += 1;
    }
  }

  get opKey() {
    return `opOtherTag-${this.key}`;
  }
  openOverlayPanel(event: Event) {
    this.page = 1;
    const refs: any = this.$refs;
    refs?.[this.opKey]?.toggle(event);
  }
  closeOverlayPanel(event: Event) {
    const refs: any = this.$refs;
    refs?.[this.opKey]?.hide(event);
  }
}
